import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import cn from 'classnames';
import AssessmentPreviewPlayer, {
  QuestionPreviewPlayer,
  AssessmentPreviewPlayerBB,
} from 'legacy-src/shared/PreviewPlayer';
import LEARNOSITY_CONFIG from 'legacy/src/components/learnosity/utils/config';
import TeacherQuestionPlayer from 'chameleon-src/components/blueBook/TeacherQuestionPlayer';
import TeacherTopicQuestionPlayer from 'chameleon-src/components/blueBook/TeacherTopicQuestionPlayer';
import { getSelectedPlayer } from './utils';

import './PreviewItem.scss';

class PreviewItem extends PureComponent {
  static displayName = 'PreviewItem';

  static propTypes = {
    subjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    offlineOnly: PropTypes.bool,
    displayTags: PropTypes.bool,
    isQBCreateTab: PropTypes.bool,
    items: PropTypes.array,
    itemsWithLrnRef: PropTypes.array,
    navigation: PropTypes.element,
    showQuestionInfo: PropTypes.bool,
    showQuestionOverview: PropTypes.bool,
    showQuestionBookmark: PropTypes.bool,
    showQuestionIndex: PropTypes.bool,
    showshowCalculatorAllowedIcon: PropTypes.bool,
    learnosityConfig: PropTypes.object,
    onQuestionChanged: PropTypes.func,
    isFinalExam: PropTypes.bool,
    isTopicQuestion: PropTypes.bool,
  };

  static defaultProps = {
    offlineOnly: false,
    displayTags: true,
    isQBCreateTab: false,
    items: [],
    itemsWithLrnRef: [],
    navigation: null,
    showQuestionInfo: true,
    showQuestionOverview: true,
    showQuestionIndex: true,
    showQuestionBookmark: true,
    showshowCalculatorAllowedIcon: true,
    learnosityConfig: LEARNOSITY_CONFIG,
    isFinalExam: false,
    isTopicQuestion: false,
  };

  render() {
    const {
      itemId,
      offlineOnly,
      displayTags,
      isQBCreateTab,
      itemIds,
      navigation,
      showQuestionInfo,
      showQuestionOverview,
      showQuestionIndex,
      showshowCalculatorAllowedIcon,
      showQuestionBookmark,
      learnosityConfig,
      isSingleQuestionPreview,
      params: { subject: subjectId },
      onQuestionChanged,
      onItemLoad,
      isFinalExam,
      getCurrentQuestionIndex,
      subjectId: subjectInitId,
      isReordering,
      onOrderChange,
      blueBookUiFlag,
      isTopicQuestion,
      itemsWithLrnRef,
      onItemChange,
    } = this.props;

    const playerProps = {
      itemId,
      subjectId,
      displayTags,
      showQuestionInfo,
      showQuestionOverview,
      showQuestionIndex,
      showQuestionBookmark,
      showshowCalculatorAllowedIcon,
      learnosityConfig,
      isSingleQuestionPreview,
      onQuestionChanged,
      onItemLoad,
      isReordering,
      onOrderChange,
      subjectInitId,
      blueBookUiFlag,
      onItemChange,
    };

    const PlayerManager = {
      Classic_Question_Preview_Player: () => {
        return (
          <QuestionPreviewPlayer
            itemIds={itemIds}
            {...playerProps}
            isQBCreateTab={isQBCreateTab}
            navigation={navigation}
            isFinalExam={isFinalExam}
          />
        );
      },
      BB_Question_Preview_Player: () => {
        return (
          <TeacherQuestionPlayer
            {...playerProps}
            isSingleQuestionPreview
            isPreviewPlayer
            itemId={itemId}
            itemIds={itemIds}
            subjectInitId={subjectInitId}
          />
        );
      },
      Classic_Assessment_Preview_Player: () => {
        return (
          <AssessmentPreviewPlayer
            {...playerProps}
            getCurrentQuestionIndex={getCurrentQuestionIndex}
          />
        );
      },
      BB_Assessment_Preview_Player: () => {
        return (
          <AssessmentPreviewPlayerBB
            {...playerProps}
            getCurrentQuestionIndex={getCurrentQuestionIndex}
          />
        );
      },
      BB_Topic_Question_Preview_Player: () => {
        return (
          <TeacherTopicQuestionPlayer
            {...playerProps}
            isSingleQuestionPreview
            isPreviewPlayer
            itemId={itemId}
            itemIds={itemIds}
            itemsWithLrnRef={itemsWithLrnRef}
            subjectInitId={subjectInitId}
          />
        );
      },
    };

    const SelectedPlayer =
      PlayerManager[
        getSelectedPlayer({ isQBCreateTab, blueBookUiFlag, isTopicQuestion })
      ]?.();

    return (
      <div className={cn('ContentPreview', 'PreviewItem', { offlineOnly })}>
        {SelectedPlayer}
      </div>
    );
  }
}

export default withRouter(PreviewItem);
